import { useParams } from "react-router-dom";
import { useState } from "react";

export default function HiringStatus() {
  const { id } = useParams();
  const [status, setStatus] = useState("Pending");

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Hiring Status</h1>

      <div className="bg-white p-6 rounded-xl shadow border w-96">
        <label className="block mb-2 font-medium">Select Status</label>

        <select
          className="border p-2 rounded w-full"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option>Pending</option>
          <option>Interviewing</option>
          <option>Shortlisted</option>
          <option>Selected</option>
          <option>Rejected</option>
        </select>

        <button className="mt-4 bg-green-600 text-white px-4 py-2 rounded">
          Update Status
        </button>
      </div>
    </div>
  );
}
